// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPage_container__PgzNe","adfinity_block_15609":"MainPage_adfinity_block_15609__2ZXwc"};